
<div :id="content.idHTML" :class="jel_getClassObject(content)">
  <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
  <div class="d-block">
    <Paragraphe
      :content="{
        richText: msgDetails,
        classeCSS: 'pb-1',
      }"
    />
    <button class="btn btn-primaire d-block mx-auto px-4 mt-2" @click="retour()">
      {{ content.libRetour }}
    </button>
  </div>
</div>
